import React, { Fragment, PropsWithChildren, useMemo } from 'react';
import { EmptyState } from '../general/empty-state/empty-state';
import { ListItemLayout, ListLayout } from '@keplerco/core';

export function ListChildren({ children, emptyState }: PropsWithChildren<{ emptyState: boolean }>): JSX.Element {
  const childrenArray = useMemo(() => {
    if (!children) return [];
    if (!Array.isArray(children)) return [children];

    return children.map((child, index) => {
      if (React.isValidElement(child) && child.key) {
        return child;
      }
      return { ...child, uuid: `list-item-${index}` };
    });
  }, [children]);

  if (!childrenArray.length) {
    return emptyState ? <EmptyState /> : <Fragment />;
  }

  return (
    <ListLayout>
      {childrenArray.length > 1 ? (
        <Fragment>
          {childrenArray.map(child => (
            <ListItemLayout key={React.isValidElement(child) ? child.key : child.uuid}>{child}</ListItemLayout>
          ))}
        </Fragment>
      ) : (
        <ListItemLayout>{childrenArray[0]}</ListItemLayout>
      )}
    </ListLayout>
  );
}

